import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import SelectInvoicePaymentMethod from 'Components/Organisms/SelectInvoicePaymentMethod/SelectInvoicePaymentMethod';

export default function RHFSelectInvoicePaymentMethod({ name, onChange: handleChange, ...other }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, ...rest }, fieldState: { error } }) => {
                useEffect(() => {
                    if (rest.value && error) {
                        clearErrors(name);
                    }
                }, [name, rest.value, clearErrors]);

                return (
                    <SelectInvoicePaymentMethod
                        {...rest}
                        error={error?.message}
                        onChange={(ev) => {
                            onChange(ev);
                            if (handleChange) {
                                handleChange(ev);
                            }
                        }}
                        {...other}
                    />
                );
            }}
        />
    );
}

RHFSelectInvoicePaymentMethod.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};
